(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mon-coeur-personalization')) {
    customElements.define(
      'mon-coeur-personalization',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.closest('form');
          this.input = this.querySelector('input');
          this.ids = this.dataset.variantIds.split(',').filter(Boolean);
          if (!this.form || !this.input) return;

          this.sync = () => {
            const variant = this.form.querySelector('[name="id"]');
            const active = Boolean(
              variant && this.ids.includes(variant.value)
            );
            this.hidden = !active;
            this.input.disabled = !active;
            this.input.required = active;
            this.input.setCustomValidity('');
          };

          this.validate = (event) => {
            this.sync();
            if (this.input.disabled) return;
            this.input.setCustomValidity(
              this.input.value.trim()
                ? ''
                : 'Indiquez le prénom ou le petit mot souhaité.'
            );
            if (!this.input.checkValidity()) {
              event.preventDefault();
              event.stopImmediatePropagation();
              this.input.reportValidity();
              this.input.focus();
            }
          };

          this.click = (event) => {
            if (event.target.closest(
              'button[type="submit"], input[type="submit"]'
            )) {
              this.validate(event);
            }
          };

          this.clearError = () => this.input.setCustomValidity('');
          this.form.addEventListener('change', this.sync);
          this.form.addEventListener('submit', this.validate, true);
          this.form.addEventListener('click', this.click, true);
          this.input.addEventListener('input', this.clearError);
          this.sync();
          this.timer = setInterval(this.sync, 200);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
          if (!this.form || !this.input) return;
          this.form.removeEventListener('change', this.sync);
          this.form.removeEventListener('submit', this.validate, true);
          this.form.removeEventListener('click', this.click, true);
          this.input.removeEventListener('input', this.clearError);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
